import { IconBuildingFactory2, IconFileCheck, IconQrcode, IconRoute } from '@tabler/icons-react';

export const SearchIcons = {
  document: IconFileCheck,
  product: IconQrcode,
  process: IconQrcode,
  companyProduct: IconQrcode,
  company: IconBuildingFactory2,
  chain: IconRoute
};
